import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";

import ConfirmationModal from "../../Dialogs/ConfirmationModal";
import { Color } from "../../Form/Button";
import useStyles from "./styles";

export interface ReviewBookingConfirmationModalHandles {
  open: (id: number, bookingNumber?: string) => void;
  close: () => void;
}
interface ReviewBookingConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (id: number) => void;
  loadingAction?: boolean;
}

const ReviewBookingConfirmationModal: ForwardRefRenderFunction<
  ReviewBookingConfirmationModalHandles,
  ReviewBookingConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [idValue, setIdValue] = useState<number>(0);
  const open = useCallback((id: number) => {
    if (id) setIdValue(id);
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setIdValue(0);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      type="warning"
      title={`${translate("changeStatusTo")} "${translate("underReview")}"`}
      leftIconTitle={<AiOutlineWarning color="#F79009" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.WARNING}
      textCancel={translate("noThanks")}
      textSubmit={translate("changeIt")}
      submit={() => onSubmit(idValue)}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.reviewModalContainer}>
          <div data-cy="confirmationModalWarningBody" className={classes.descriptionModalConfirm}>
            <span>
              {translate("areYouSureYouWantToChangeThisBookingStatusTo")}
              {` "${translate("underReview")}" ?`}
            </span>
            <span className="warning">{translate("theBookingWillBeSentBackToTheSupplier")}</span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(ReviewBookingConfirmationModal);
